// extracted by mini-css-extract-plugin
module.exports = {"walletConnectButton":"styles_walletConnectButton__pK_6K"};